'use client'

import { modals } from "@mantine/modals";
import { toast } from "sonner";

export const Confirm = (confirmDeleteTitle: string, confirmDeleteText: string, handleFunc: () => Promise<void>, confirmLabel: string, cancelMessage: string) => {

    modals.openConfirmModal({
        title: confirmDeleteTitle,
        children: (
            <div>
                <p>{`${confirmDeleteText}`}</p>
            </div>
        ),
        labels: { confirm: confirmLabel, cancel: 'Cancel' },
        onConfirm: () => handleFunc(),
        onCancel: () => {
            toast.info(cancelMessage);
        },
    });

}